import { gql } from '@apollo/client';

/**
 * 求揽收站点在指定日期的车型，用于新建/编辑预约单时带出默认车型。
 *
 * 前端不自行解析站点的 standingScheduleJson：排期求值在后端 PickupScheduleResolver 收口，
 * 多一份实现就是多一种口径（列表、筛选、导出曾因此互相打脸）。
 */
export const RESOLVE_PICKUP_SITE_VEHICLE_TYPE = gql`
    query ResolvePickupSiteVehicleType($cooperationWarehouseId: Long!, $expectedPickupDate: String!) {
        resolvePickupSiteVehicleType(
            cooperationWarehouseId: $cooperationWarehouseId
            expectedPickupDate: $expectedPickupDate
        )
    }
`;

export interface ResolvePickupSiteVehicleTypeResponse {
    /** 站点不存在或未配车型时为 null */
    resolvePickupSiteVehicleType?: number | null;
}
